export default __webpack_public_path__ + "static/media/Frame 8.7ef78599.svg";